export default "__VITE_ASSET__DcvZHclo__"